import Upper from "./features/Upper";
import TabNav from "./features/TabNav";
import Tab1 from "./features/Tab1";
import {useState} from "react";
import Tab2 from "./features/Tab2";
import Tab2Delivery from "../../../order/orders/detail/features/Tab2";
import {useParams} from "react-router-dom";
import {useReadPurchaseOrderDetail} from "./hooks/useReadPurchaseOrderDetail";
import {useReadPurchaseOrderSubject} from "./hooks/useReadPurchaseOrderSubject";
import {pcsDetailInit} from "./state";
import Tab1Modify from "./features/Tab1Modify";
import Tab2Modify from "./features/Tab2Modify";
import {useReadOrderSubjects} from "../../../order/orders/detail/hooks/useReadOrderSubjects";
import {useForm} from "react-hook-form";

export default function PcsDetail({isOrderRequest, isPcsDelivery}: {
    isOrderRequest?: boolean,
    isPcsDelivery?: boolean,
}) {
    const {id} = useParams()

    const [tab, setTab] = useState("tab-1");
    const [isModify, setIsModify] = useState<boolean>(false)
    const [modifyTrigger, setModifyTrigger] = useState<boolean>(false)

    const {data: pcsDetail} = useReadPurchaseOrderDetail({param: {purchaseOrderId: Number(id as string)}})
    const {data: pcsSubject} = useReadPurchaseOrderSubject({param: {purchaseOrderId: Number(id as string)}})

    const btnSave = () => {
        setModifyTrigger(true)
    }

    const menuTitleText = () => {
        if (isOrderRequest) {
            return "수주 요청 "
        } else if (isPcsDelivery) {
            return "납품 "
        } else {
            return "발주 "
        }
    }

    const urlText = () => {
        if (isOrderRequest) {
            return "order/orderRequest"
        } else if (isPcsDelivery) {
            return "purchase/delivery"
        } else {
            return "purchase/pcs"
        }
    }

    const {data: ordersSubjectApiData} = useReadOrderSubjects({
        param: pcsDetail?.newShipmentId as string,
        enabled: !!pcsDetail && !!isPcsDelivery  // 내부수정: isPcsDelivery일 때만 호출
    })
    const ordersSubject = ordersSubjectApiData ?? []

    const {
        register: registerSubject,
        getValues: getValuesSubject,
        setValue: setValueSubject,
        control: controlSubject,
        handleSubmit: handleSubmitSubject,
        watch: watchSubject
    } = useForm({
        defaultValues: ordersSubject,
    })

    return <>
        <Upper pcsDetail={pcsDetail ?? pcsDetailInit}
               isModify={isModify}
               setIsModify={setIsModify}
               btnSave={btnSave}
               menuTitleText={menuTitleText()}
               urlText={urlText()}
               isAvailableOrder={isOrderRequest}
               isPcsDelivery={isPcsDelivery}/>

        <TabNav tab={tab}
                setTab={setTab}
                isModify={isModify}
                menuTitleText={menuTitleText()}/>

        {tab === "tab-1"
            ? !isModify
                ? <Tab1 pcsDetail={pcsDetail ?? pcsDetailInit}
                        menuTitleText={menuTitleText()}
                        isPcsDelivery={isPcsDelivery}
                />
                : <Tab1Modify
                    pcsDetail={pcsDetail ?? pcsDetailInit}
                    setIsModify={setIsModify}
                    modifyTrigger={modifyTrigger}
                    setModifyTrigger={setModifyTrigger}
                    menuTitleText={menuTitleText()}
                    isPcsDelivery={isPcsDelivery}
                />
            : !isPcsDelivery
                ? <>
                    {!isModify
                        ? <Tab2 pcsSubject={pcsSubject ?? []}
                                menuTitleText={menuTitleText()}/>
                        : <Tab2Modify
                            pcsDetail={pcsDetail ?? pcsDetailInit}
                            pcsSubject={pcsSubject ?? []}
                            setIsModify={setIsModify}
                            modifyTrigger={modifyTrigger}
                            setModifyTrigger={setModifyTrigger}
                            menuTitleText={menuTitleText()}/>}
                </>
                : <Tab2Delivery ordersSubject={ordersSubject}
                                btnToggleModify={() => null}
                                wonUnit={watchSubject("wonUnit")}
                                register={registerSubject}
                                isDeadline={false}
                                isPcsDelivery={isPcsDelivery}
                />
        }
    </>
}